import Vue from 'vue';
import GMap from "\u002Fusr\u002Fsrc\u002Fnuxt-app\u002Fnode_modules\u002Fnuxt-gmaps\u002Fcomponents\u002FGMap.vue";
import GMapMarker from "\u002Fusr\u002Fsrc\u002Fnuxt-app\u002Fnode_modules\u002Fnuxt-gmaps\u002Fcomponents\u002FGMapMarker.vue";
import GMapCircle from "\u002Fusr\u002Fsrc\u002Fnuxt-app\u002Fnode_modules\u002Fnuxt-gmaps\u002Fcomponents\u002FGMapCircle.vue";
import GMapInfoWindow from "\u002Fusr\u002Fsrc\u002Fnuxt-app\u002Fnode_modules\u002Fnuxt-gmaps\u002Fcomponents\u002FGMapInfoWindow.vue";
export default(context, inject) =>{
  Vue.component('GMap', GMap);
  Vue.component('GMapMarker', GMapMarker);
  Vue.component('GMapCircle', GMapCircle);
  Vue.component('GMapInfoWindow', GMapInfoWindow);
  inject('GMaps', {apiKey: "AIzaSyDirgdQ4ga6NKOEi5HaYt1QOmm2b5FyTM0", loaded: false, libraries: undefined})
}